/**
 * Nawigacja pomiędzy sekcjami na karcie produktu
 */
app.service('productTabs', function (productTabDescription, productTabAccessories, productTabSeeAlso, html, productTabInstalments, productTabQuestion, productTabMatches, productMenu, productTabOpinions, productTabServices, productSeeRecommended, productTabWarranties, broker, loading, pageConfig, productSalesTabs, sufficientOutletCategory, front, productTopSeeRecommended, wcProductTabWarranties, productTabOutlet, outletManager, console, dynamicSuite) {
	var $self, $tabs = false,
		activeTab = false;
	let outletCategoryInitialLoad = false;

	function clickTab(tab) {
		console.log('Kliknięcie na zakładkę: ' + tab);
		if (tab === activeTab) {
			$('.tab-' + tab).removeClass('active');
			activeTab = false;
		} else {
			$tabs.removeClass('active');
			$('.tab-'+tab).addClass('active');
			activeTab=tab;
		}
	}
	function scrollTabByHash() {
		var hash = document.location.hash;
		switch( hash ) {
			case '#zestawy':
				productMenu.scroll('zestawy');
				break;
			case '#akcesoria':
				productMenu.scroll('akcesoria');
				break;
			case '#opis':
				productMenu.scroll('opis');
				break;
			case '#pytania':
				productMenu.scroll('pytania');
				break;
			case '#opinie':
				productMenu.scroll('opinie');
				break;
			case '#uslugi':
				productMenu.scroll('uslugi');
				break;
			case '#outlet':
				productMenu.scroll('outlet');
				break;
			case '#gwarancje':
				productMenu.scroll('gwarancje');
				break;
			case '#raty':
				productMenu.scroll('raty');
				break;
			case '#pasuje-do':
				productMenu.scroll('pasuje-do');
				break;
		}
		if( hash.indexOf('#opinia-') === 0 ) {
			var opinionId = hash.slice(8);
			$.scrollTo( '#opinion-' + opinionId );
		}
		if(hash.indexOf('#outlet') === 0 || hash.indexOf('#afterSearch-outlet') === 0 || (hash.indexOf('|hu-')>-1 && hash.indexOf('|outlet-')>-1)){
			outletManager.checkHash(hash);
		}
	}

	function reloadTabs(data) {
		var saveTab = $('#menu-product').attr('data-tab');
		loading.start();
		var outletMode=data.outletCategoryId!=="new";
		var ajaxData={
			productId: data.productId
		}
		if(outletMode){
			ajaxData.outletCategoryId=data.outletCategoryId;
		}
		const tabInstalments = productTabInstalments.reload(ajaxData);
		if (front.katalog) {
			var tabWarranties = wcProductTabWarranties.reload(ajaxData);
		} else {
			var tabWarranties = productTabWarranties.reload(ajaxData);
		}
		const tabServices = productTabServices.reload(ajaxData);

		$.when(tabInstalments, tabWarranties, tabServices)
			.then(() => {
				toggleOutletTabs(outletMode);
				productMenu.outletMode(outletMode);

				if(data.scroll==='outlet'){				//do zakładki outlet
					console.log('Scroll do zakładki outlet');
					productMenu.scroll('outlet');
				}
				if(data.scroll==='tab'){				//do początku aktualnej zakładki
					if(data.tab){
						console.log('Scroll do zakładki: '+data.tab);
						productMenu.scroll(data.tab);
					}else {
						console.log('Scroll do ostatniej zakładki: '+saveTab);
						productMenu.scroll(saveTab, 0);
					}
				}
				if(data.scroll==='hu' && data.huCode){
					$.scrollTo('.outlet-product-individual-offers');

					var hash = document.location.hash;
					if (hash.indexOf('|preview') > -1) {				//wariant z otwarciem HU
						console.log('Otwieranie HU');
						productTabOutlet.showIndividualOutletOffer(data.huCode);
					}
				}
			})
			.always(() => {
				loading.stop();
				outletCategoryInitialLoad= false;
			});
	}

	function toggleOutletTabs(outletMode){
		if(outletMode){
			$self.addClass('outlet-tabs');
		}else{
			$self.removeClass('outlet-tabs');
		}
	}
	function tabChange(data){
		//console.log(data)
		if(data && data.nextTab){
			$self.attr('data-tab', data.nextTab);
		}else{
			$self.removeAttr('data-tab');
		}
	}

	function setEvents() {
		broker.on('CHANGE_PRODUCT_CATEGORY', function(e, data){
			reloadTabs(data);
		});

		broker.on('PRODUCT_MENU_TAB_CHANGE', function (e, data){
			tabChange(data);
		});

		$tabs.children('a').click(function(){
			clickTab($(this).data('tab'));
		});
		$('.js-scroll-by-hash').on('click', function(event) {
			if ($(this).attr('href').split('#')[1] == window.location.href.split('#')[1]) {
				scrollTabByHash();
			} else {
				window.location = $(this).attr('href');
			}
			event.preventDefault();
		});
		$(window).on('hashchange', function() {
			scrollTabByHash();
		});
	}
	function setElements(){
		$self=$('#product-tabs');
		$tabs=$self.children('.tab');
	}
	function isGoogleReferrer(){
		return front.isGoogleReferrer();
	}
	function init(){
		setElements();
		setEvents();
		if(isGoogleReferrer()){
			productTopSeeRecommended.init();
		}else{
			productSeeRecommended.init();
		}

		dynamicSuite.init();
		productTabDescription.init();
		productTabAccessories.init();
		productTabMatches.init();
		productTabServices.init();
		if (front.katalog) {
			wcProductTabWarranties.init();
		} else {
			productTabWarranties.init();
		}
		productTabSeeAlso.init();
		productTabOpinions.init();
		productTabQuestion.init();
		productTabInstalments.init();
		productTabOutlet.init();
		productMenu.init();
		scrollTabByHash();
	}
	return {
		init
	};
});
